type SavePath = (path: string, id?: string) => Promise<{ id?: string }>;

export const createLatestPathSaveQueue = () => {
  let pending: { path: string; savePath: SavePath } | undefined;
  let inFlightPath: string | undefined;
  let queue: Promise<void> = Promise.resolve();
  let entityId: string | undefined;
  const getLatestPath = () => pending?.path ?? inFlightPath;

  return {
    enqueue(path: string, savePath: SavePath, initialEntityId?: string) {
      entityId ??= initialEntityId;

      if (getLatestPath() === path) {
        return queue;
      }

      pending = { path, savePath };

      queue = queue
        .catch(() => undefined)
        .then(async () => {
          while (pending) {
            const next = pending;

            pending = undefined;
            inFlightPath = next.path;

            try {
              const saved = await next.savePath(next.path, entityId);

              entityId = saved.id ?? entityId;
            } finally {
              inFlightPath = undefined;
            }
          }
        });

      return queue;
    },
    getLatestPath,
  };
};
